module.exports = __webpack_public_path__ + "img/shipo-icon-edit-upload.fb5b1e4d.svg";